import * as types from './types';

const initialState = {
  entities: [],
  isFetchingEntities: false,
};

export default (state = initialState, action) => {
  const { type, payload } = action;
  switch (type) {
    case types.SET_ENTITIES:
    case types.SET_IS_FETCHING_ENTITIES:
      return {
        ...state,
        ...payload,
      };
    default:
      return state;
  }
};
